import MessageBox from './MessageBox.vue'
export default {
  install:(app,option) =>{
    app.component(MessageBox.name,MessageBox)
  }
}